import navigationItems from '../navigationItems/index.js';

var footerNavigation = [{
  groupLabel: 'Editing tools',
  groupUrl: null,
  groupList: [navigationItems.photoEditor, navigationItems.videoEditor, navigationItems.apps, navigationItems.forDevelopers, navigationItems.quicktools, navigationItems.businessSolutions, navigationItems.forGoogleDrive, navigationItems.adMaker]
}, {
  groupLabel: 'About',
  groupUrl: null,
  groupList: [navigationItems.aboutUs, navigationItems.pressKit, navigationItems.career, navigationItems.support, navigationItems.brands, navigationItems.affiliates, navigationItems.blog]
}, {
  groupLabel: 'Everything Picsart',
  groupUrl: null,
  groupList: [navigationItems.explore, navigationItems.hashtags, navigationItems.challenges, navigationItems.artists]
}, {
  groupLabel: 'Legal',
  groupUrl: null,
  groupList: [navigationItems.tc, navigationItems.privacy, navigationItems.communityGuidelines, navigationItems.ethyca, navigationItems.interestBasedAds, navigationItems.DMCA, navigationItems.securityPolicy]
}];

export { footerNavigation as default };
//# sourceMappingURL=index.js.map
